export function getFileName(url) {
  let headInd = url.lastIndexOf('/') + 1,
      tailInd = url.lastIndexOf('.');

  // if(headInd === -1) headInd = 0;
  if(tailInd === -1) tailInd = undefined;

  return url.slice(headInd, tailInd);
}


export function getFileIdList(objSortedNameURL) {
  const typeList = ['img', 'pdf', 'video'],
        len1 = typeList.length;

  let fileIdList = [];

  for(let i = 0; i < len1; i++) {
    const arrURL = objSortedNameURL[typeList[i]],
          len2 = arrURL.length;

    for(let j = 0; j < len2; j++) {
      fileIdList.push(getFileName(arrURL[j]));
    }
  }

  return fileIdList;
}


// WEBPACK FOOTER //
// ./src/commonJS/getFileName.js